// Version : 0.0.1
// Author : AGALYA

/* eslint-disable import/no-anonymous-default-export */
import progressReportTypes from './progress-report.types';
import { docodeHexResponse } from '../../_common/common.utils';

const INITIAL_STATE = {
	getProgressReportResponse: null,
	getProgressReportArr: [],
};

export default (state = INITIAL_STATE, action: any) => {
	switch (action.type) {
		/************** GET PROGRESS REPORT START **************************** */
		case progressReportTypes.GET_PROGRESS_REPORT_SUCCESS:
			return {
				...state,
				getProgressReportResponse: action.payload,
				getProgressReportArr: docodeHexResponse(action.payload, 'GetBranchProgressListKey'),
			};

		case progressReportTypes.GET_PROGRESS_REPORT_FAILURE:
			return {
				...state,
				getProgressReportResponse: action.payload,
				getProgressReportArr: [],
			};

		case progressReportTypes.GET_PROGRESS_REPORT_RESPONSE_CHANGED:
			return { ...state, getProgressReportResponse: null };
		/************** GET PROGRESS REPORT END **************************** */
		default:
			return state;
	}
};
